import styles from './MakeMoneyTransfer.module.css'
import {LGBTButton} from "../../components/lgbtButton/LGBTButton";
import { Link, useNavigate } from 'react-router-dom';
import { useRef } from 'react';
export const MakeMoneyTransfer = ({onClose}:{onClose:()=>void})=>{
    const navigation = useNavigate();
    const refLinc = useRef<HTMLAnchorElement>(null)
    const onTransfer=()=>{
        if(refLinc.current){
            refLinc.current.click();
        }
        onClose();
        navigation("*")
    }

    return(
        <div className={styles.transfer_container}>
            <span className={styles.transfer_title}>Ваш результат сохранен</span>
            <LGBTButton onClick={()=>onTransfer()}

                        children={<div className={styles.button_money_transfer}>Сделать благотворительный перевод</div>} />
        <Link 
        to="https://messenger.online.sberbank.ru/sl/z5r7R1rMldSEzwSLI" 
        target="_blank" 
        ref={refLinc}
        style={{display:"none", width:"0px", height:"0px", opacity:"0"}}></Link>
        </div>
    )
}